/**
 * Force every page load (initial + refresh) to start at the top of the page.
 * Disables the browser's scroll-position restoration and scrolls to 0,0 both
 * synchronously and on the `load` event (catches late layout shifts from
 * images/fonts). Anchor clicks within the page are untouched — they only
 * cause hashchange, not a full load, so this script doesn't re-fire.
 */
(function () {
  if ('scrollRestoration' in window.history) {
    window.history.scrollRestoration = 'manual';
  }
  window.scrollTo(0, 0);
  window.addEventListener('load', function () { window.scrollTo(0, 0); });
})();
